export default __webpack_public_path__ + "static/media/dalenhotel.268e67ea.jpg";